import { createContext, useContext } from 'react';

/** Arbitrary string ID for guide visibility. Workflows and drawers can use any ID without registering. */
export type ContextGuideID = string;

export const DefaultContextGuideConfig = {
  contextGuide: {} as Record<string, boolean>,
};

export const DefaultContextGuideMethods = {
  setGuide: (_guideID: ContextGuideID, _value: boolean) => ({}),
  getGuide: (_guideID: ContextGuideID) => false,
};
type DefaultContextGuideConfigType = typeof DefaultContextGuideConfig;
type DefaultContextGuideMethodsType = typeof DefaultContextGuideMethods;

export interface ContextGuideContextProps extends DefaultContextGuideMethodsType, DefaultContextGuideConfigType {}

export const DefaultContextGuideContext = { ...DefaultContextGuideConfig, ...DefaultContextGuideMethods };
export const ContextGuideContext = createContext(DefaultContextGuideContext);
ContextGuideContext.displayName = 'ContextGuideContext';
export const useContextGuide = () => useContext(ContextGuideContext);
